import { extractEntity } from './tournamentsApi';
import { extractPlayersPage, playerDisplayName } from './playersApi';

export const BLACKLIST_PAGE_SIZE = 40;
export const BLACKLIST_COMMENT_MAX = 255;

export const blacklistPlayerId = (item) => {
  const id = Number(item?.id ?? item?.player_id ?? item?.playerId);
  return Number.isFinite(id) && id > 0 ? id : null;
};

export const extractBlacklistPage = (data) => extractPlayersPage(data);

export const extractBlacklistPlayer = (data) => {
  if (Array.isArray(data)) return data[0] || null;
  const entity = extractEntity(data);
  if (!entity || typeof entity !== 'object') return null;
  const id = blacklistPlayerId(entity);
  if (!id && entity.blacklisted == null) return null;
  return { ...entity, id: id || entity.id };
};

export const blacklistDisplayName = (item) => playerDisplayName(item) || (item?.id ? `#${item.id}` : '');

export const formatBlacklistDate = (value, lang = 'ru') => {
  const ts = Number(value);
  if (!Number.isFinite(ts) || ts <= 0) return '';
  const ms = ts < 1e12 ? ts * 1000 : ts;
  const date = new Date(ms);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString(lang === 'en' ? 'en-GB' : 'ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const blacklistComment = (item) => (
  item?.blacklistedComment || item?.comment || ''
);

export const trimBlacklistComment = (value) => String(value || '').trim().slice(0, BLACKLIST_COMMENT_MAX);
